import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import { FaPiggyBank, FaHistory, FaBars } from "react-icons/fa";
import { HiLogout } from "react-icons/hi";

import useDeviceType from "../../hook/useDeviceType";
import { usePreviousPagePath } from "../../hook/usePreviousPagePath";
import { isLoggedIn } from "../../utils/isLoggedIn";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { useEffect, useMemo, useState } from "react";
import { RiMore2Fill } from "react-icons/ri";
import GameBoxMore from "./components/gameBoxMore";
import { enterPlayGame } from "../../api/postApi";
import { isEmptyObject } from "../../utils/isEmptyObject";
import {
  clearGameLink,
  openVipBar,
  openAccessTool,
  storeGameConfig,
  storeGameLink,
  openFullScreen,
  closeVipBar,
  startGameLoading,
  endGameLoading,
} from "../../redux/action/game/gameAction";
import { Base64 } from "js-base64";
import { BiSolidError } from "react-icons/bi";
import { Button, Loader } from "semantic-ui-react";
import useGetNowGame from "../../hook/useGetNowGame";
import { useTranslation } from "react-i18next";
import useGameIsHasDescription from "./gameDescription/gameIsHasDescription";
import {
  openChat,
  openGameDescriptionPop,
  triggerGameBoxTransfer,
} from "../../redux/action/member/memberAction";
import Cookies from "js-cookie";
import Draggable from "react-draggable";
import NoticeTransfer from "./components/noticeTransfer";
import useDetectedPlayerWalletBalance from "../../hook/useDetectedPlayerWalletBalance";
import { transferGameLang } from "./utils/transferGameLang";
import i18next from "i18next";
import { MdOutlineScreenShare } from "react-icons/md";
import useTransferMode from "../../hook/useTransferMode";
import { IoGameController } from "react-icons/io5";
import ToolTab from "./components/toolTab";

const iconStyle = "text-2xl mr-[10px]";

const GameBox = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`gamebox.${key}`);

  const dispatch = useDispatch();
  const gameLink = useSelector((state) => state.isGameLink);
  const isOpenFullScreen = useSelector((state) => state.isOpenFullScreen);
  const gameConfig = useSelector((state) => state.isGameConfig);
  const singleWallet = useSelector(
    (state) => state.isMemberInfo.gameWalletInfo
  );
  const gameTrigger = useSelector((state) => state.isTriggerGameLink);
  const transferWallet = useSelector((state) => state.isTransferWallet);
  const gameLoading = useSelector((state) => state.isGameLoading);
  const isAccessToolOpen = useSelector((state) => state.isAccessTool);

  const isMobile = useDeviceType() === "Mobile";

  const [showBar, setShowBar] = useState(true);
  const [toolbarHint, setToolbarHint] = useState(true);
  const [showGameBoxMore, setShowGameBoxMore] = useState(false);
  const [showAlertPop, setShowAlertPop] = useState(false);
  const [testing, setTesting] = useState(false);
  const [triggerTransferPop, setTriggerTransferPop] = useState(false);
  const [isNotSupportIframe, setIsNotSupportIframe] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);
  const [isTransferModePop, setIsTransferModePop] = useState(false);
  const [firstRender, setFirstRender] = useState(true);

  const isTransferMode = useTransferMode();

  useEffect(() => {
    if (isTransferMode) {
      setIsTransferModePop(true);
    } else {
      setIsTransferModePop(false);
    }
  }, [isTransferMode]);

  const nowGameConfig = useGetNowGame();

  useEffect(() => {
    if (isEmptyObject(gameConfig)) {
      dispatch(storeGameConfig(nowGameConfig));
    }
  }, [nowGameConfig]);

  useEffect(() => {
    if (firstRender) {
      dispatch(closeVipBar());
      setFirstRender(false);
    }
    dispatch(startGameLoading());
    setShowAlertPop(false);
    if (!isEmptyObject(gameConfig)) {
      enterPlayGame({
        gameUid: gameConfig.gameUid,
        gameCode: gameConfig.gameCode,
        isMobile: isMobile ? 2 : 1,
        lang: transferGameLang(i18next.language),
      })
        .then((data) => {
          if (data?.not_supported_iframe) {
            window.open(Base64.decode(data.url), "_blank");
          }
          setIsNotSupportIframe(data.not_supported_iframe);
          dispatch({ type: "GET_BALANCE" });

          if (!data.not_supported_iframe) {
            if (
              gameConfig?.game_type === "LIVE" ||
              gameConfig?.game_type === "SPORT" ||
              gameConfig?.game_type === "LOTTERY"
            ) {
              dispatch(openFullScreen());
            }
          }
          setShowAlertPop(false);
          setIsPortrait(data.portrait); //這裡從後端拿到的portrait判斷是直式還是橫式
          dispatch(storeGameLink(Base64.decode(data.url)));
          dispatch(endGameLoading());
        })
        .catch((err) => {
          if (err.name === "CanceledError") {
            return;
          }
          setShowAlertPop(true);
        })
        .finally(() => {});
    }
  }, [gameConfig, i18next.language, gameTrigger]);

  const deviceType = useDeviceType();

  const { to } = useParams();

  const gameIsHasDescription = useGameIsHasDescription({ game_platform: to });

  useEffect(() => {
    if (gameIsHasDescription && !isMobile && Cookies.get(`notice_${to}`) != 1) {
      dispatch(openGameDescriptionPop({ game: to }));
    }
  }, [gameIsHasDescription, isMobile]);

  useEffect(() => {
    setTimeout(() => {
      setToolbarHint(false);
    }, 3000);
  }, []);

  const navigate = useNavigate();

  const detectedPlayerWalletBalanceBiggestThanZero =
    useDetectedPlayerWalletBalance({ to });
  return (
    <main className="flex flex-col overflow-hidden w-full md:min-h-[calc(100%-52px)] md:h-[calc(100%-52px)] min-h-[calc(100vh-52px)]  lg:static webkit-height fixed top-0 left-0 z-[1001]">
      {triggerTransferPop && isTransferMode && !isEmptyObject(gameConfig) ? (
        <NoticeTransfer
          triggerTransferPop={triggerTransferPop}
          setTriggerTransferPop={setTriggerTransferPop}
        />
      ) : null}
      {/* {loadingGame && (
        <div className="absolute w-full h-full top-0 left-0 bg-black flex items-center justify-center text-light-white">
          <Loader size="large" active inline="centered">
            {i18n("loading")}
          </Loader>
        </div>
      )} */}
      {gameLoading ? (
        <div
          className={`lg:h-full h-[100vh] ${
            isOpenFullScreen && "!h-[calc(100vh-47.5px)]"
          } w-full  bg-[#272727] md:rounded-b-xl flex items-center justify-center text-white`}
        >
          <Loader size="large" active inline="centered">
            {i18n("loading")}
          </Loader>
        </div>
      ) : isTransferModePop && !isMobile ? (
        <div
          className={`lg:h-full h-[100vh] ${
            isOpenFullScreen && "!h-[calc(100vh-47.5px)]"
          } w-full  bg-[#272727] md:rounded-b-xl flex items-center justify-center`}
        >
          <div className="flex flex-col items-center gap-[20px] text-base-white">
            <IoGameController className="text-[100px] text-yellow-500" />
            {/* <span className="text-2xl">
              {!detectedPlayerWalletBalanceBiggestThanZero
                ? i18n("pleaseTransfer")
                : i18n("needTransferFirst")}
            </span> */}
            <section className="grid grid-cols-3 gap-[10px]">
              <Button
                type="button"
                onClick={() => {
                  if (gameLoading) return;
                  if (isNotSupportIframe) {
                    window.open(gameLink, "_blank");
                  } else {
                    setIsTransferModePop(false);
                  }
                }}
                content={i18n("openGame")}
                size="xl"
                className="!bg-main-color !text-white col-span-2 !w-full !py-[17px] !mt-[20px]"
              />
              <Button
                type="button"
                onClick={() => {
                  dispatch(openVipBar());
                  dispatch(triggerGameBoxTransfer());
                }}
                content={i18n("transfer")}
                size="xl"
                className="!bg-green-500 !text-white col-span-1 !w-full !py-[17px] !mt-[20px]"
              />
            </section>
          </div>
        </div>
      ) : isNotSupportIframe ? (
        <div
          className={`lg:h-full h-[100vh] ${
            isOpenFullScreen && "!h-[calc(100vh-47.5px)]"
          } w-full px-[30px] bg-[#272727] md:rounded-b-xl flex items-center justify-center`}
        >
          <div className="flex flex-col items-center gap-[20px] text-base-white">
            <MdOutlineScreenShare className="text-[100px] text-yellow-500" />
            <span className="text-2xl">{i18n("gameNotSupportIframe")}</span>
            <Button
              type="button"
              onClick={() => {
                window.open(gameLink, "_blank");
              }}
              content={i18n("openGame")}
              size="xl"
              className="!bg-main-color !text-white !w-full !py-[17px] !mt-[20px]"
            />
          </div>
        </div>
      ) : showAlertPop ? (
        <div
          className={`lg:h-full h-[100vh] ${
            isOpenFullScreen && "!h-[calc(100vh-47.5px)]"
          } w-full  bg-[#272727] md:rounded-b-xl flex items-center justify-center`}
        >
          <div className="flex flex-col items-center gap-[20px] text-base-white">
            <BiSolidError className="text-[100px] text-red-500" />
            <span className="text-2xl">
              {i18n("The game link is abnormal")}
            </span>
            <Button
              type="button"
              onClick={() => {
                dispatch(openChat());
              }}
              content={i18n("contactCustomerServiceNow")}
              size="xl"
              className="!bg-main-color !text-white !w-full !py-[17px] !mt-[20px]"
            />
          </div>
        </div>
      ) : (
        <section
          className="relative w-full flex flex-col h-full bg-black"
          id="game-iframe"
        >
          {testing && (
            <div className="absolute w-full h-full top-0 left-0 bg-black flex items-center justify-center">
              <span className="text-4xl text-base-white">
                {i18n("gameIsTestingPleaseDontPlay")}
              </span>
            </div>
          )}

          <iframe
            src={gameLoading ? "" : gameLink}
            className={`lg:h-full webkit-height ${
              isOpenFullScreen && "!h-[calc(100vh-47.5px)]"
            } ${!isOpenFullScreen && "w-[330px] mx-auto"} ${
              isPortrait ? "!w-[70%]" : "" // 條件渲染，如果是直式，設定寬度為 70%
            } w-full bg-[#272727] md:rounded-b-xl`}
          ></iframe>

          {!showBar && deviceType === "Mobile" && (
            <div
              onClick={() => {
                setShowBar(true);
              }}
              className="fixed h-[20px] w-[50px] rounded-t-lg bg-main-color flex items-center justify-center absolute-center !top-[99%]"
            >
              <AiFillEye className="text-light-white text-xl" />
            </div>
          )}
        </section>
      )}
      {deviceType === "Mobile" && <ToolTab />}

      {isAccessToolOpen && (
        <GameBoxMore setShowGameBoxMore={setShowGameBoxMore} />
      )}
    </main>
  );
};

export default GameBox;
